module.exports = __webpack_public_path__ + "img/club-event.a91656ed.jpg";